import { render, staticRenderFns } from "./MatchHeader.vue?vue&type=template&id=2fafbe57&scoped=true"
import script from "./MatchHeader.vue?vue&type=script&lang=js"
export * from "./MatchHeader.vue?vue&type=script&lang=js"
import style0 from "./MatchHeader.vue?vue&type=style&index=0&id=2fafbe57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fafbe57",
  null
  
)

export default component.exports